export default function calledlistdatas(state = [], action) {
  switch (action.type) {
    case 'ADD_CURRENT':
        return {
            ...state,
            calledlistdata: action.calledlistdata,
        }
    case 'ADD_CURRENT_ORGANIZATION':
        return {
            ...state,
            calledlistdata: action.calledlistdata,
            organization: action.organization,
        }
      default:
          return state;
  }
}